import { Component, OnInit } from '@angular/core';
import { ContactsService } from '../../../service/component_dependent/contacts/contacts.service';
import { Data } from '../../../model/data';
import { ConversationService } from '../../../service/component_dependent/messages/conversation.service';
import { Conversations } from '../../../model/conversations';
import { StorageService } from '../../../service/managers/storage.service';
import { Messages } from '../../../model/messages';
import { JsonManager } from '../../../service/managers/json-manager';
import { MessagesService } from '../../../service/component_dependent/messages/messages.service';
import { NotifierService } from '../../../service/component_dependent/notifier.service';
import { MobKitService } from '../../../service/component_dependent/messages/mob-kit.service';
import { YonduService } from '../../../service/component_dependent/messages/yondu.service';
import { Schedules } from '../../../model/schedules';
import { SchedulesService } from '../../../service/component_dependent/messages/schedules.service';
import { GroupsService } from '../../../service/component_dependent/groups.service';
import { Router } from '@angular/router';

import {Subject} from "rxjs";
import {debounceTime, distinctUntilChanged} from "rxjs/internal/operators";

@Component({
  selector: 'app-messages-compose',
  templateUrl: './messages-compose.component.html',
  styleUrls: ['./messages-compose.component.scss']
})
export class MessagesComposeComponent implements OnInit {

  protected contactsGroupsList: Array<Data>;
  protected contactsGroupsSelectedItems: Array<Data> = new Array<Data>();

  protected senderList: Array<Data>;
  protected senderListSelectedItems: Array<Data> = new Array<Data>();

  protected dropdownSettings = {};
  protected dropdownFromSettings = {};

  protected schedule: Schedules = null;

  protected message: string;

  private isSuccessful: boolean = true;
  private isScheduled: boolean = false;
  private isExecuted: boolean = false;

  txtQueryChanged: Subject<string> = new Subject<string>();

  public headers: any = [];
  public headersLength: any = 12;


  constructor(private contactsService: ContactsService,
    private conversationService: ConversationService,
    private storageService: StorageService,
    private messageService: MessagesService,
    private notifierService: NotifierService,
    private mobKitService: MobKitService,
    private scheduleService: SchedulesService,
    private yonduService: YonduService,
    private groupService: GroupsService,
    private router: Router) {

      this.txtQueryChanged
      .pipe(debounceTime(700), distinctUntilChanged())
      .subscribe(keyword => {
        console.log('SUBSCRIBE:' + keyword)
          this.contactsService.getContactsOrGroups(keyword).subscribe(
            (dataContacts: any) => {
              this.reassignVariablesContactsGroupsList(dataContacts);
            }
          )
       // api call
   });

    this.initComponents();

  }


  ngOnInit() {

  }

  protected onFilterChange(keyword: string) {
    console.log('TYPING:' + keyword)
     this.txtQueryChanged.next(keyword)
  }

  protected onSetSchedule(p, dateTime: any) {
    if (p.isOpen()) {
      p.close();
    }

    this.schedule = new Schedules();
    this.schedule.added_by = this.storageService.getUser().id;
    this.schedule.date_time_schedule = dateTime;
    this.schedule.status = 2;
  }

  protected async onSent() {
    let contactIDS;
    let conversations: Array<Conversations>;
    let self = this;
    let userID;
    let scheduleID;
    let content;
    let sendType;

    userID = this.storageService.getUser().id;
    content = this.message;

    this.isSuccessful = true;
    this.isScheduled = false;
    this.isExecuted = true;

    if (content == null || content.length <= 0) {
      this.isExecuted = false;
      this.notifierService.showError("Content is required.");
    }

    if (this.senderListSelectedItems.length <= 0) {
      this.isExecuted = false;
      this.notifierService.showError("Sender type is required.");
    }

    if (this.isExecuted) {

      if (this.schedule != null) {
        await this.scheduleService.createSchedule(this.schedule).toPromise().then(
          (dateSchedule: any) => {
            scheduleID = dateSchedule.data.id;
            this.isScheduled = true;
          },
          (errorSchedule: any) => {
            this.isScheduled = false;
            this.notifierService.showError(errorSchedule.error.message);
          }
        );
      }

      console.log('Contact Selected:' + JSON.stringify(this.contactsGroupsSelectedItems))

      
      //Pass the contact number id split type
      var msg = {
         'contact_number_ids': this.contactsGroupsSelectedItems,
         'message': this.message,
         'from' : this.senderListSelectedItems[0].title
      }

      //Send this data to backend
      this.messageService.sendNewMessage(msg).subscribe(
        (data) => console.log('MSG:' + JSON.stringify(data))
      )

      //console.log(msg)

      // this.messageService.createMessage(message).subscribe(
      //   (dataMessage: any) => {
  
      //     var mobKitMessage = {
      //       To: conversationSelected.contact_number.country_code + conversationSelected.contact_number.number,
      //       Message: message.content,
      //       id: dataMessage.data.id,
      //     }
      //   });

      // await this.getFilterSelectedIDsToContactsIDs().then(async function (result) {
      //   contactIDS = result;
      //   conversations = self.createConversationArray(contactIDS.length);

      //   if (result.length > 0) {

      //     for (var i = 0; i < conversations.length; i++) {
      //       var message: Messages;
      //       var mobile_number: string;

      //       message = new Messages();
      //       message.contact_number_id = contactIDS[i];
      //       message.schedules_id = scheduleID;
      //       message.send_type = Number(self.senderListSelectedItems[0].title);

      //       await self.contactsService.getContactNumber(message.contact_number_id).toPromise().then(
      //         (dataContacts: any) => {
      //           mobile_number = dataContacts.data.mobile_number;
      //         },
      //         (errorContacts: any) => {
      //           self.notifierService.showError(errorContacts.error.message);
      //         },
      //       );

      //       await self.conversationService.getConversationByContactNumberID(userID, message.contact_number_id).toPromise().then(
      //         (dataConversation: any) => {
      //           self.createMessage(dataConversation, message, mobile_number);
      //         },
      //         async (errorConversation: any) => {
      //           await self.conversationService.createConversation(conversations[i]).toPromise().then(
      //             (dataConversation: any) => {
      //               self.createMessage(dataConversation, message, mobile_number);
      //             },
      //             (errorConversation: any) => {
      //               self.notifierService.showError(errorConversation.erorr.message);
      //             }
      //           );
      //         }
      //       );
      //     }

      //   } else {

      //     self.isSuccessful = false;
      //     self.notifierService.showError("Please select a contact number.");

      //   }


      // });

      if (this.isScheduled && this.isSuccessful) {
        this.notifierService.showSuccess("Successfully set schedule for message.");
        //this.router.navigateByUrl("/joytogive/messages/all");
      } else if (this.isSuccessful && !this.isScheduled) {
        this.notifierService.showSuccess("Message is sending.");
        //this.router.navigateByUrl("/joytogive/messages/all");
      }
    }

  }

  private initComponents() {

    this.initSenderList();

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'title',
      textField: 'description',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,
      maxHeight: 200,
    };

    this.contactsService.getContactsOrGroups('').subscribe(
      (dataContacts: any) => {
        this.reassignVariablesContactsGroupsList(dataContacts);
      }
    )
  }

  private initSenderList() {
    var dataA;
    var dataB;

    dataA = new Data();
    dataA.title = '1';
    dataA.description = 'World Vision';

    dataB = new Data();
    dataB.title = '2';
    dataB.description = '09178485412';

    this.senderList = new Array<Data>();
    this.senderList.push(dataA, dataB);

    this.dropdownFromSettings = {
      singleSelection: true,
      idField: 'title',
      textField: 'description',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    }
  }

  private reassignVariablesContactsGroupsList(dataContacts: any) {
    var size;
    var data: Data;

    size = dataContacts.length;

    if (size != 0) {
      this.contactsGroupsList = new Array<Data>();
      for (var i = 0; i < size; i++) {
        data = new Data();
        data.title = dataContacts[i].id + " " + dataContacts[i].source;
        data.description = (dataContacts[i].name == null) ? dataContacts[i].sub_name : dataContacts[i].name;
        this.contactsGroupsList.push(data);
      }
    }
  }

  private async getFilterSelectedIDsToContactsIDs() {

    let contactIDS = [];
    var id: string;
    var type: string;

    for (var i = 0; i < this.contactsGroupsSelectedItems.length; i++) {
      var tmp: string[];

      tmp = this.contactsGroupsSelectedItems[i].title.split(' ');

      id = tmp[0];
      type = tmp[1];

      if (type == 'groups') {

        await this.contactsService.getContactNumbersByGroupID(parseInt(id)).toPromise().then(
          (dataContacts: any) => {
            var data;

            data = dataContacts.data;
            for (var i = 0; i < data.length; i++) {
              if (contactIDS.indexOf(data[i].id) == -1) {
                contactIDS.push(parseInt(data[i].id));
              }
            }
          },
          (errorContacts: any) => {
            this.notifierService.showError(errorContacts.error.message);
          }
        );

      } else {
        if (contactIDS.indexOf(parseInt(id)) == -1) {
          contactIDS.push(parseInt(id));
        }
      }
    }

    return contactIDS;
  }

  private createConversationArray(contactIDSLength: number) {
    var conversations: Array<Conversations>;
    var conversation: Conversations;

    conversations = new Array<Conversations>();

    for (var i = 0; i < contactIDSLength; i++) {
      var userID = this.storageService.getUser().id;

      conversation = new Conversations();

      conversation.assigned_by = userID;
      conversation.assigned_to = userID;
      conversation.title = '';
      conversations.push(conversation);
    }

    return conversations;
  }

  private async createMessage(dataConversation: any, message: Messages, mobile_number: string) {

    message.conversations_id = dataConversation.data.id;
    message.users_id = this.storageService.getUser().id;
    message.content = this.message;
    message.is_deleted = 0;
    message.is_incoming = 0;
    message.is_unread = 0;
    message.status = 2;
    message.date_time_sent = JsonManager.getDateTime();

    await this.messageService.createMessage(message).toPromise().then(

      async (dataMessage: any) => {
        let mobkitMessage;

        mobkitMessage = {
          To: mobile_number,
          Message: message.content,
          id: dataMessage.data.id,
        }

        if (message.schedules_id == null) {

          if (message.send_type == 2) {
            await this.mobKitService.sendMessage(mobkitMessage).toPromise().then(
              (mobKitData: any) => {

              },
              (errorMobKit: any) => {
                this.isSuccessful = false;
                this.notifierService.showError(errorMobKit.error.message);
              },
            );
          } else if (message.send_type == 1) {
            await this.yonduService.sendMessage(mobkitMessage).toPromise().then(
              (mobKitData: any) => {

              },
              (errorMobKit: any) => {
                this.isSuccessful = false;
                this.notifierService.showError(errorMobKit.error.message);
              },
            );
          }
        }
      },

      (errorMessage: any) => {
        this.isSuccessful = false;
        this.isScheduled = false;
        this.notifierService.showError(JsonManager.getBreakLineSeparatedErrorMessages(errorMessage.error.message));
      }

    );
  }


  //******** MERGE FIELDS  */
  showMergeFields(){
    //Get the Group ID of the Selected Record 
     if(this.contactsGroupsSelectedItems.length != 1){
        //Produce an error
     }else if(this.contactsGroupsSelectedItems.length == 1){
        //Continue get the value 
        const title = this.contactsGroupsSelectedItems[0].title.split(" ");
        const id = title[0];
        const type = title[1];
        //Check if groups then check custom values
        if(type=='groups'){
           //alert('Group check custom value:' + id)
           this.groupService.getCustomGroupHeader(id).subscribe(
             (data) => {
               alert('Console data groups headers')
               console.log('Group Data:' + JSON.stringify(data))
               this.headers = data;

               if(this.headers.length > 0){
                  this.headersLength = 8;
               }

             },(err) =>{
              alert('Error:' + err)
             }
           )
        }        
     }
  }


  addMerge(row){
    this.message = this.message + '{{' + row + '}}'
  }

}
